import React from 'react';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import { Collapse } from 'reactstrap';
import Products from '../../Models/Products';
import { Link } from 'react-router-dom';
import { AffiliatorCart } from './AffiliatorCart';
import { AffiliatorProfileDetails } from './AffiliatorProfileDetails';
import Cookies from 'universal-cookie';
import Affiliator from '../../Models/Affiliator';
import StarRatings from 'react-star-ratings';
import StarRatingComponent from 'react-star-rating-component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Spinner } from 'reactstrap';
const cookies = new Cookies();
class AffiliatorProductsDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            collapse: false,
            modal: false,
            productDetails: [],
            favouriteDetails: '',
            sellerDetails: '',
            favouriteRemoveDetails: [],
            counter: '',
            productId: '',
            affiliatorStatus: '',
            cookiesAll: [],
            reviews: [],
            status: [],
            discription: '',
            layer: 5,
            single: [],
            image: '',
            flag: '',
            ratings: '',
            ratings: [],
            multipleImage: [],
            multipleImages: [],
            rating: 0,
            aff_from_link: 0
        };
        var link = window.location.pathname;
        window.localStorage.setItem('link', link)
        let url = window.location.pathname.split('/');
        let ids = url[url.length - 2];
        let name = url[url.length - 1];
        let aff_name = name.split('-');
        let user_name = aff_name[aff_name.length - 2];
        let aff_link = url[url.length - 3]
        let total_link = (aff_link + '/' + ids + '/' + name)
        this.state.aff_from_link = user_name
        let data = {
            link: total_link
        }
        Affiliator.sendAffiliatorLink(data).then(res => {
            this.setState({ id: ids })
            if (res.data.status === 200) {
                this.setState({ cookiesAll: res.data.payload })
            } else if (res.data.status === 10077) {
                this.setState({ status: res.data.status })
            }
        })
        this.getAffiliatoName(user_name);
        this.getDetails(ids);
        this.getImage(ids);
        this.getSellerDetails(ids);
        this.getFavouriteCounter(ids);
        this.getReview();
        this.getRating(ids);
        console.log(ids)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    getRating() {
        var x = JSON.parse(localStorage.getItem('info'))
        let url = window.location.pathname.split('/');
        let id = url[url.length - 2];
        if (x === null) {
            Products.getReview(id, 0).then(res => {
                this.setState({ rating: res.data.overall })
            })
        } else {
            Products.getReview(id, x.id).then(res => {
                this.setState({ rating: res.data.overall })
            })
        }
    }

    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    getFavouriteCounterComp() {
        let x = JSON.parse(localStorage.getItem('info'));
        if (x !== null) {
            Products.getFavouriteCounter(this.props.location.state.id, x.id).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload
                })
            })
        } else {
            Products.getFavouriteCounter(this.props.location.state.id, 0).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload
                })
            })
        }
    }

    handleShowFavouriteMessage() {
        alert('自分が出品したサービスはお気に入りすること出来ません！')
    }

    favourite() {
        // var x = JSON.parse(localStorage.getItem('info'))
        if ((localStorage.getItem('info')) === null || (localStorage.getItem('info')) === '') {
            return (
                <div>
                    <Button className="btn btn-secondary " style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px', height: '32px' }} onClick={this.toggleAll.bind(this)}>お気に入り</Button>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            ログインしてください。
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>閉じる</Button>
                        </ModalFooter>
                    </Modal>
                </div >

            )
        } else {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.id === this.state.sellerDetails) {
                return (
                    <div>
                        <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.handleShowFavouriteMessage.bind(this)}>お気に入り</button>
                    </div>
                )
            } else {
                if (this.state.favouriteDetails === 1) {
                    return (
                        <div>
                            <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px'}} onClick={this.handleFavourite.bind(this)}>お気に入り</button>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <button className="btn btn-secondary" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '110px' }} onClick={this.handleRemoveFavourite.bind(this)}><i className="fas fa-heart mr-1" style={{ color: 'red' }} ></i> 登録済み</button>
                        </div>
                    )
                }
            }
        }
    }

    details(details) {
        if (details === null || details === '') {
            return (
                <div>
                    <span>{details}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details}</Collapse></span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>全て見る</div> */}
                    {this.onRead()}
                </div>
            )
        } else {
            return (
                <div>
                    <span>{details.substr(0, 50)}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details.substr(51, 1000)}</Collapse></span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>全て見る</div> */}
                    {this.onRead()}
                </div>
            )
        }
    }

    getAffiliatoName(name) {
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            Affiliator.getAffiliator(name).then(res => {
                if (res.data.status === 200) {
                    this.setState({ affiliatorStatus: res.data.status })
                } else {
                    this.setState({ affiliatorStatus: res.data.status })
                }
            })
        } else {
            Affiliator.getAffiliator(name).then(res => {
                if (res.data.status === 200) {
                    let url = window.location.pathname.split('/');
                    let id = url[url.length - 2];
                    let x = JSON.parse(localStorage.getItem('info'))
                    let data = {
                        buyer_id: x.id,
                        product_id: id,
                        affiliator_id: res.data.message
                    }
                    Affiliator.sendAffiliatorInfo(data).then(res => {
                        console.log(res.data)
                    })
                    this.setState({ affiliatorStatus: res.data.status })
                } else {
                    this.setState({ affiliatorStatus: res.data.status })
                }
            })
        }
    }

    getReview() {
        const x = JSON.parse(localStorage.getItem('info'))
        let url = window.location.pathname.split('/');
        let id = url[url.length - 2];
        if (x === null || x === '') {
            Products.getReview(id, 0).then(res => {
                this.setState({ reviews: res.data.payload, flag: res.data.flag })
            })
        } else {
            Products.getReview(id, x.id).then(res => {
                this.setState({ reviews: res.data.payload, flag: res.data.flag })
            })
        }
    }

    getSellerDetails(id) {
        Products.getProductsDetails(id).then(res => {
            res.data.seller.map(res =>
                this.setState({ sellerDetails: res.id })
            )
        })
    }

    getDetails(id) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            Products.getProductsDetails(id, 3).then(res => {
                if (res.data.multiples.length < 3 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
        //for tablet view
        else if (isTablet) {
            Products.getProductsDetails(id, 2).then(res => {
                if (res.data.multiples.length < 4 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
        //for desktop view
        else if (isDesktop) {
            Products.getProductsDetails(id, 1).then(res => {
                if (res.data.multiples.length <= 5 && res.data.multiples.length > 0) {
                    res.data.multiples.push({
                        img: res.data.product[0].img
                    })
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                } else {
                    this.setState({ productDetails: res.data.product, status: res.data.status, single: res.data.product_single, multipleImage: res.data.multiples, layer: res.data.multiples.length })
                }
            })
        }
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    getImage(id) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            Products.getProductsDetails(id, 3).then(res => {
                console.log(res.data)
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
        //for tablet view
        else if (isTablet) {
            Products.getProductsDetails(id, 2).then(res => {
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
        //for desktop view
        else if (isDesktop) {
            Products.getProductsDetails(id, 1).then(res => {
                res.data.multiples.push({
                    img: res.data.product[0].img
                })
                this.setState({ multipleImages: res.data.multiples })
            })
        }
    }

    getFavouriteCounter(id) {
        const x = JSON.parse(localStorage.getItem('info'));
        if (x !== null) {
            Products.getFavouriteCounter(id, x.id).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload
                })
            })
        } else {
            Products.getFavouriteCounter(id, 0).then(res => {
                this.setState({
                    favouriteDetails: res.data.flag,
                    counter: res.data.payload
                })
            })
        }
    }

    handleFavourite() {
        const x = JSON.parse(localStorage.getItem('info'));
        let url = window.location.pathname.split('/');
        let id = url[url.length - 2]
        Products.getFavourite(id, x.id).then(res => {
            this.setState({
                favouriteDetails: res.data.flag,
                counter: this.state.counter + 1,
            })
        })
    }

    handleRemoveFavourite() {
        const x = JSON.parse(localStorage.getItem('info'));
        let url = window.location.pathname.split('/');
        let id = url[url.length - 2]
        Products.getRemoveFavourite(id, x.id).then(res => {
            this.setState({ favouriteDetails: res.data.flag, counter: this.state.counter - 1 })
        })
    }

    onRead(des, details) {

        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (this.state.collapse === true) {
            return (<div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer' }}>
                <Collapse isOpen={this.state.collapse}>{renderHTML(details)}</Collapse>
                <i className="fas fa-angle-up"></i></div>
            )
        } else {
            return (<div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer' }}>{renderHTML(des)}全て見る</div>
            )
        }
    }

    details(details) {
        if (details === null || details === '') {
            return (
                <div>
                    <span>{details}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details}</Collapse></span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>全て見る</div> */}
                    {this.onRead()}
                </div>
            )
        } else {
            return (
                <div>
                    <span>{details.substr(0, 50)}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details.substr(51, 1000)}</Collapse></span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>全て見る</div> */}
                    {this.onRead()}
                </div>
            )
        }
    }

    handleClick(img) {
        this.setState({ image: img })
    }

    handleClickButton(i, j) {
        const isMobile = window.innerWidth <= 500;
        const isTablet = window.innerWidth > 500 && window.innerWidth < 1200;
        const isDesktop = window.innerWidth >= 1200;
        //for mobile view
        if (isMobile) {
            console.log(j)
            Products.getProductsImage(i, j, 3).then(res => {
                if (res.data.images != null) {
                    if (res.data.images.length < 3) {
                        console.log(res.data.images)
                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images, layer: 1 })
                    } else {
                        this.setState({ multipleImage: res.data.images, layer: j + 3 })
                    }
                    console.log(this.state.multipleImage)
                }
                console.log(this.state.layer)
            })

        } else if (isTablet) {
            if (j === 6) {
                Products.getProductsImage(i, j, 2).then(res => {
                    if (res.data.images != null) {

                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images })
                    }
                })
                this.setState({ layer: 1 })
            } else if (j === 1) {
                Products.getProductsImage(i, j, 2).then(res => {
                    if (res.data.images != null) {
                        this.setState({ multipleImage: res.data.images })
                    }
                })
                this.setState({ layer: 6 })
            }
        } else if (isDesktop) {
            if (j === 6) {
                Products.getProductsImage(i, j, 1).then(res => {
                    console.log(res.data.images)
                    console.log(j)
                    if (res.data.images != null) {
                        // if (res.data.images.length < 10 && res.data.images.length > 5) {
                        //     res.data.images.push({
                        //         img: this.state.productDetails[0].img
                        //     })
                        //     this.setState({ multipleImage: res.data.images })
                        // } else {
                        res.data.images.push({
                            img: this.state.productDetails[0].img
                        })
                        this.setState({ multipleImage: res.data.images })
                        // }
                    }
                })
                this.setState({ layer: 1 })
            } else if (j === 1) {
                Products.getProductsImage(i, j, 1).then(res => {
                    console.log(res.data.images)
                    if (res.data.images != null) {
                        this.setState({ multipleImage: res.data.images })
                    }
                })
                this.setState({ layer: 6 })
            }
        }
    }

    suffleButton(id, layer) {
        console.log(layer)
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            console.log(this.state.multipleImages.length)
            if (this.state.multipleImages.length > 0 && this.state.multipleImages.length > 3) {
                return (
                    <div id="div1" className="mb-2 mobile_image_next_button" style={{ marginLeft: '475px', cursor: "pointer", opacity: '.75', zIndex: '200', position: "absolute" }} onClick={this.handleClickButton.bind(this, id, layer)}>
                        <img alt="" src={require('../../assets/images/arrow2.png')} className="rounded-circle" style={{ height: '35px', width: '35px', marginTop: '30px', verticalAlign: 'middle', backgroundColor: 'black' }} />
                    </div>
                )
            } else {
                return (
                    <div className="" style={{ zIndex: '200', position: "relative" }}></div>
                )
            }
        }
        //for desktop view
        else if (isDesktop) {
            if (this.state.multipleImages.length > 0 && this.state.multipleImages.length > 5) {
                return (
                    <div id="div1" className="mb-2 mobile_image_next_button" style={{ marginLeft: '475px', cursor: "pointer", opacity: '.75', zIndex: '200', position: "absolute" }} onClick={this.handleClickButton.bind(this, id, layer)}>
                        <img alt="" src={require('../../assets/images/arrow2.png')} className="rounded-circle" style={{ height: '35px', width: '35px', marginTop: '30px', verticalAlign: 'middle', backgroundColor: 'black' }} />
                    </div>
                )
            } else {
                return (
                    <div className="" style={{ zIndex: '200', position: "relative" }}></div>
                )
            }
        }
    }

    imageShow(i) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.image) {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '9px' }}>
                        <img src={this.state.image} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            } else {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '9px' }}>
                        <img src={i} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            }
        }
        //for desktop view
        else if (isDesktop) {
            if (this.state.image) {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '12px' }}>
                        <img src={this.state.image} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            } else {
                return (
                    <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '12px' }}>
                        <img src={i} className="img-responsive" alt="" height="100%" width="100%" />
                    </div>
                )
            }
        }
    }

    multipleImageShow(id) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.multipleImage.length > 0) {
                return (
                    <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '91px' }}>
                        {this.state.multipleImage.map((res, i) =>
                            <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px', width: '33%' }} onClick={this.handleClick.bind(this, res.img)}>
                                <img src={res.img} className="img-responsive " alt="" height="85" width="100%" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                            </div>
                        )}
                        {this.suffleButton(id, this.state.layer)}
                        <div>&nbsp;</div>
                    </div>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        } else if (isDesktop) {
            if (this.state.multipleImage.length > 0) {
                return (
                    <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '100px' }}>
                        {this.state.multipleImage.map((res, i) =>
                            <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px' }} onClick={this.handleClick.bind(this, res.img)}>
                                <img src={res.img} className="img-responsive " alt="" height="94" width="100" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                            </div>
                        )}
                        {this.suffleButton(id, this.state.layer)}
                        <div>&nbsp;</div>
                    </div>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        }
    }

    render() {
        if (parseInt(this.state.status) === 10077) {
            console.log(this.state.status)
            return (
                <div>
                    <h1>Page not found</h1>
                    <p>We're sorry, we couldn't find the page you requested.</p>
                </div>
            )
        } else if (this.state.cookiesAll.length > 0) {
            let url = window.location.pathname.split('/');
            let id = url[url.length - 2]
            const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
            const isMobile = window.innerWidth <= 500;
            if (isMobile) {
                return (
                    <div>
                        <Header />
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 "> </div>
                        <div className="container_fluid">
                            <div className="">
                                <div className="col-md-1"></div>
                                <div className="col-md-7">
                                    {this.state.productDetails.map(res =>
                                        <div className="" key={res.id}>
                                            <span style={{ fontsize: '9px' }}>
                                                <Link to={{
                                                    pathname: `/categories/${res.category_id}`,
                                                    state: { id: res.category_id }
                                                }} style={{ textDecoration: 'none' }} className="category-right">
                                                    {res.category_main} /
                                                    </Link>
                                                <Link to={{
                                                    pathname: `/sub-categories/${res.sub_category_id}`,
                                                    state: { id: res.sub_category_id }
                                                }} style={{ textDecoration: 'none', }} className="category-right">
                                                    {res.category_sub}
                                                </Link>
                                            </span>
                                        </div>
                                    )}
                                    {/* <div>&nbsp;</div> */}
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-11">
                                                <div className="row">
                                                    {this.state.productDetails.map(res =>
                                                        <div key={res.id}>
                                                            <div className="col-md-12">
                                                                <div className="big_font" style={{ fontSize: '20px' }}>
                                                                    <span>{res.title}</span>
                                                                </div>
                                                                <div className="product_mini_text" style={{ fontSize: '13px' }}>
                                                                    {res.short_desc}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="text-right">
                                                    <div className="width_100">
                                                        <div className="like" style={{ width: '100%' }}>
                                                            <div className="row ">
                                                                <div className="col-md-8 stars ">
                                                                    <StarRatings
                                                                        rating={this.state.rating}
                                                                        starDimension="20px"
                                                                        starSpacing="5px"
                                                                        starRatedColor="#FFD700"
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mt-2 text-right">
                                                                    <div className="row ml-0" >
                                                                        <div className="">
                                                                            {this.favourite()}
                                                                        </div>
                                                                        <div className="text-center ml-1" style={{ backgroundColor: '#ccc', border: '1px solid #ccc', width: '55px', height: '38px', padding: '8px', borderRadius: '5px' }}>
                                                                            {this.state.counter}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr style={{ width: "97%", marginTop: '6px', marginBottom: '6px' }} />
                                                {this.state.productDetails.map(res =>
                                                    <div key={res.id}>
                                                        {this.multipleImageShow(res.id)}
                                                        {/* <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '91px' }}>
                                                        {this.state.multipleImage.map((res, i) =>
                                                            <div className="pb-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '6px', width: '33%' }} onClick={this.handleClick.bind(this, res.img)}>
                                                                <img src={res.img} className="img-responsive " alt="" height="85" width="100%" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                                                            </div>
                                                        )}
                                                        {this.suffleButton(res.id, this.state.layer)}
                                                        <div>&nbsp;</div>
                                                    </div> */}
                                                        {this.imageShow(res.img)}
                                                        <div>&nbsp;</div>
                                                        <div className="content_details card" style={{ border: '0px solid', fontSize: '13px' }}>
                                                            <div className="">
                                                                {this.onRead(res.trimed_long_desc, res.long_desc)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div>&nbsp;</div>
                                                <div className="main_rev">
                                                    <div>
                                                        {this.state.reviews.map(res =>
                                                            <div key={res.id} style={{ fontSize: '13px' }}>
                                                                <div className="special_width_2"></div>
                                                                <div className="">
                                                                    <div className="review_box col-md-9" style={{ width: '100%', border: '1px solid #ccc', borderRadius: '5px' }}>
                                                                        <div className="row">
                                                                            <div className="col-7">
                                                                                <span> {res.buyer}</span>
                                                                            </div>
                                                                            <div className="col-5" style={{ textAlign: 'end' }}>
                                                                                <span className="font_12" >{(JSON.stringify(res.created_at)).substring(1, 11)}</span><br />
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            <span className="">
                                                                                <StarRatingComponent
                                                                                    name="rate1"
                                                                                    starCount={5}
                                                                                    value={res.stars}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        <div className="">
                                                                            <span className="">{res.comment.split('\n').map(function (item, key) {
                                                                                return (
                                                                                    <span key={key}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </span>
                                                                                )
                                                                            })}
                                                                            </span>
                                                                            <br />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <AffiliatorCart state={
                                        {
                                            aff_id: this.state.aff_from_link,
                                            id: this.state.id,
                                            available: this.state.single.no_of_order_at_atime,
                                            self: this.state.single.self_affiliate
                                        }
                                    } />
                                    <AffiliatorProfileDetails id={id} />
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                        </div>
                        <Footer className="mt-3" />
                    </div>

                )
            } else {
                return (
                    <div>
                        <Header />
                        <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                        <div className="container_fluid">
                            <div className="container">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7">
                                            {this.state.productDetails.map(res =>
                                                <div className="col-md-12 font_12" key={res.id}>
                                                    <span>
                                                        <Link to={{
                                                            pathname: `/categories/${res.category_id}`,
                                                            state: { id: res.category_id }
                                                        }} style={{ textDecoration: 'none' }} className="category-right">
                                                            {res.category_main} /
                                                </Link>
                                                        <Link to={{
                                                            pathname: `/sub-categories/${res.sub_category_id}`,
                                                            state: { id: res.sub_category_id }
                                                        }} style={{ textDecoration: 'none', }} className="category-right">
                                                            {res.category_sub}
                                                        </Link>
                                                    </span>
                                                </div>
                                            )}
                                            <div>&nbsp;</div>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-11">
                                                        {/* <div className="row">
                                                        {this.state.productDetails.map(res =>
                                                            <div key={res.id}>
                                                                <div className="col-md-1 badge_details">
                                                                </div>
                                                                <div className="col-md-11">
                                                                    <div className="big_font">
                                                                        <span>{res.title}</span>
                                                                    </div>
                                                                    <div className="product_mini_text">
                                                                        {res.short_desc}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div> */}
                                                        <div className="row">
                                                            {this.state.productDetails.map(res =>
                                                                <div key={res.id}>
                                                                    <div className="col-md-12">
                                                                        <div className="big_font" style={{ fontSize: '20px' }}>
                                                                            <span>{res.title}</span>
                                                                        </div>
                                                                        <div className="product_mini_text" style={{ fontSize: '15px' }}>
                                                                            {res.short_desc}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* <div>&nbsp;</div> */}
                                                        <div className="second_line text-right">
                                                            <div className="width_100">
                                                                <div className="like" style={{ width: '100%' }}>
                                                                    <div className="row ">
                                                                        <div className="col-md-8 stars ">
                                                                            <StarRatings
                                                                                rating={this.state.rating}
                                                                                starDimension="20px"
                                                                                starSpacing="5px"
                                                                                starRatedColor="#FFD700"
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-4 text-right">
                                                                            <div className="row ">
                                                                                <div className="">
                                                                                    {this.favourite()}
                                                                                </div>
                                                                                <div className="text-center ml-1" style={{ padding: '8px', backgroundColor: '#ccc', border: '1px solid #ccc', width: '55px', height: '38px', borderRadius: '5px' }}>
                                                                                    {this.state.counter}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.productDetails.map(res =>
                                                            <div key={res.id}>
                                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                                                    {this.multipleImageShow(res.id)}
                                                                    {/* {this.state.multipleImage.map((res, i) =>
                                                                        <div className="mt-2" key={res.id} style={{ paddingLeft: '0px', paddingRight: '13px' }} onClick={this.handleClick.bind(this, res.img)}>
                                                                            <img src={res.img} className="img-responsive " alt="" height="90" width="90" style={{ objectFit: 'cover', border: '1px solid #ccc' }} />
                                                                        </div>
                                                                    )}
                                                                    {this.suffleButton(res.id, this.state.layer)} */}
                                                                    <div>&nbsp;</div>
                                                                </div>
                                                                {this.imageShow(res.img)}
                                                                <div>&nbsp;</div>
                                                                <div className="content_details card" style={{ border: '0px solid' }}>
                                                                    <div className="card-body">
                                                                        {this.onRead(res.trimed_long_desc, res.long_desc)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div>&nbsp;</div>

                                                        <div>&nbsp;</div>
                                                        <div className="main_rev">
                                                            <div>&nbsp;</div>
                                                            <div>&nbsp;</div>
                                                            <div>
                                                                <table>
                                                                    {this.state.reviews.map(res =>
                                                                        <tbody key={res.id}>
                                                                            <tr>
                                                                                <td className="special_width">
                                                                                    <img src={res.img_buyer} className="img-responsive img-circle" alt="" width="100" height="100" />&nbsp;&nbsp;
                                                                            </td>
                                                                                <td className="special_width_2"></td>
                                                                                <td className="review_box">
                                                                                    <div className="row">
                                                                                        <div className="col-md-4">
                                                                                            <span>by {res.buyer}</span>
                                                                                        </div>
                                                                                        <div className="col-md-4">
                                                                                            <span className="ml-2">
                                                                                                <StarRatingComponent
                                                                                                    name="rate1"
                                                                                                    starCount={5}
                                                                                                    value={res.stars}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-md-4">
                                                                                            <span className="float_right">{(JSON.stringify(res.created_at)).substring(1, 11)}</span><br />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="">
                                                                                        <span className="font_12">{res.comment}</span><br />
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    )}
                                                                </table>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div>&nbsp;</div>
                                                            {/* {this.showReview()} */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            {/* <AffiliatorCart id={id} /> */}
                                            <AffiliatorCart state={
                                                {
                                                    aff_id: this.state.aff_from_link,
                                                    id: this.state.id,
                                                    available: this.state.single.no_of_order_at_atime,
                                                    self: this.state.single.self_affiliate
                                                }
                                            } />
                                            <AffiliatorProfileDetails id={id} />
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <Footer className="mt-3" />
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '300px' }}></div>
                        <div className="text-center mt-5">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export { AffiliatorProductsDetails }